import { Controller } from 'react-hook-form';
import { SelectInputField } from '../SelectInputField';

export const contractTypeOptions = [
  { value: 1, label: '1 month' },
  { value: 6, label: '6 months' },
  { value: 12, label: '12 months' },
  { value: 18, label: '18 months' },
  { value: 24, label: '24 months' },
  { value: 30, label: '30 months' },
  { value: 36, label: '36 months' },
  { value: 60, label: '60 months' },
];

export const normalizeContractDurationMonths = (value, fallback = 1) => {
  if (value === '' || value === null || value === undefined) return fallback;
  if (typeof value === 'number' && Number.isFinite(value)) return value;

  const asString = String(value).toLowerCase().trim();
  if (asString === 'monthly') return 1;
  if (asString === 'annually' || asString === 'annual') return 12;

  const parsed = Number(asString);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const ContractTypeSelectField = ({
  control,
  errors,
  error,
  name = 'contract_duration',
  label = 'Contract Duration',
  placeholder = 'Select option',
  disabled = false,
  options = contractTypeOptions,
  ...selectProps
}) => {
  const resolvedError =
    error ??
    name
      ?.split('.')
      .reduce((acc, key) => acc?.[key], errors)
      ?.message;

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <SelectInputField
          {...field}
          {...selectProps}
          label={label}
          placeholder={placeholder}
          options={options}
          error={resolvedError}
          disabled={disabled}
          value={field?.value === null || field?.value === undefined ? '' : field.value}
          onChange={(e) => {
            const nextValue = e?.target?.value;
            field.onChange(nextValue === '' ? '' : Number(nextValue));
          }}
        />
      )}
    />
  );
};
